import { Typography } from "antd";
import { CrossAccessFormModal } from "@/modules/organization-cross-access/components/CrossAccessFormModal";
import { CrossAccessTable } from "@/modules/organization-cross-access/components/CrossAccessTable";
import { useUrlTableState } from "@/shared/hooks/useUrlState";

const { Text } = Typography;

interface OrgCrossAccessTabProps {
	organizationId: string;
}

export function OrgCrossAccessTab({ organizationId }: OrgCrossAccessTabProps) {
	const { page, limit, setPage } = useUrlTableState({ prefix: "ca" });

	return (
		<div>
			<div className="mb-4">
				<Text type="secondary">
					Ushbu tashkilotga tegishli kirish huquqlari (ko'ruvchi yoki maqsad sifatida)
				</Text>
			</div>

			<CrossAccessTable
				page={page}
				limit={limit}
				onPageChange={setPage}
				organizationId={organizationId}
			/>
			<CrossAccessFormModal />
		</div>
	);
}
